import { render, staticRenderFns } from "./calculate.vue?vue&type=template&id=fae4d3ba"
import script from "./calculate.vue?vue&type=script&lang=js"
export * from "./calculate.vue?vue&type=script&lang=js"
import style0 from "./calculate.vue?vue&type=style&index=0&id=fae4d3ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports